exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-74788724]::-webkit-inner-spin-button,input[data-v-74788724]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.tanpawrap[data-v-74788724]{white-space:nowrap}", ""]);

// exports
